import React from 'react';
import { CreateButton, TopToolbar, useListContext } from 'react-admin';
import { ContactShareButtons } from './ContactShareButtons.tsx';
import type { ContactFilter } from '../contactExport.ts';
import { ImportButton } from '../../data-import/ImportButton.tsx';

const ContactExportButtons: React.FC = () => {
  const { filterValues, selectedIds } = useListContext();

  const hasSelection = selectedIds.length > 0;
  const scopeLabel = hasSelection ? `Selected (${selectedIds.length})` : 'All';

  return (
    <ContactShareButtons
      // Selected rows win over the current filter, matching the group page.
      filter={(filterValues ?? {}) as ContactFilter}
      ids={hasSelection ? selectedIds.map(Number) : undefined}
      scopeLabel={scopeLabel}
      filename={`contacts-${new Date().toISOString().slice(0, 10)}.csv`}
      dialogHeading="Share Contacts"
      defaultSubject="Contacts"
      defaultMessage="The contact list is attached."
      successMessage="Contacts sent"
    />
  );
};

// Top toolbar when nothing is selected; the bulk toolbar replaces it once rows
// are checked, so the same buttons are mounted in both places.
export const ContactListActions: React.FC = () => (
  <TopToolbar>
    <CreateButton />
    <ImportButton kind="contacts" />
    <ContactExportButtons />
  </TopToolbar>
);

export const ContactBulkActions: React.FC = () => <ContactExportButtons />;
